// extracted by mini-css-extract-plugin
export default {"box":"EmployeeSkills_box__Ktu82","employeeSkills":"EmployeeSkills_employeeSkills__3OdAD","employeeSkillsBody":"EmployeeSkills_employeeSkillsBody__mD-w3"};